import * as HLF from "html-living-framework";

export class LayoutNineSliceSprite extends PIXI.Container {

    protected _sprite?: PIXI.NineSlicePlane;
    protected _anchorX: number = 0;
    protected _anchorY: number = 0;

    public constructor (
        public readonly leftWidth?: number,
        public readonly topHeight?: number,
        public readonly rightWidth?: number,
        public readonly bottomHeight?: number,
    ) {
        super();
    }

    public get anchorX() {
        return this._anchorX;
    }
    public get anchorY() {
        return this._anchorY;
    }

    public setLayoutTexture(texture: string, anchorX: number, anchorY: number) {
        if (typeof texture === "string") {
            texture = texture.replace(/\.png$|\.jpe?g$/, "");
            texture = texture.replace(/@2x$|@1x$/, "");
            this.name = texture;
        }

        if (this._sprite === undefined) {
            this._sprite = this.addChild(new PIXI.NineSlicePlane(
                HLF.PixiUtils.getTexture(texture),
                this.leftWidth,
                this.topHeight,
                this.rightWidth,
                this.bottomHeight,
            ));
        }
        else {
            this._sprite.texture = HLF.PixiUtils.getTexture(texture);
            this._sprite.textureUpdated();
        }

        this._anchorX = anchorX;
        this._anchorY = anchorY;
        this._sprite.position.x = -anchorX * this._sprite.texture.width;
        this._sprite.position.y = -anchorY * this._sprite.texture.height;
    }

    public setNineSliceScale(pScaleX: number, pScaleY: number) {
        if (this._sprite) {
            this._sprite.width = this._sprite.texture.width * pScaleX;
            this._sprite.height = this._sprite.texture.height * pScaleY;

            this._sprite.position.x = -this._anchorX * this._sprite.width;
            this._sprite.position.y = -this._anchorY * this._sprite.height;
        }
    }

    public onLayout() {
        //
    }
}